/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkcodehint3Inputs */

const en_profilelinkcodehint3 = /** @type {(inputs: Profilelinkcodehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code has 6 digits and is valid for 10 minutes.`)
};

const de_profilelinkcodehint3 = /** @type {(inputs: Profilelinkcodehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Code hat 6 Ziffern und gilt 10 Minuten.`)
};

/**
* | output |
* | --- |
* | "The code has 6 digits and is valid for 10 minutes." |
*
* @param {Profilelinkcodehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkcodehint3 = /** @type {((inputs?: Profilelinkcodehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkcodehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkcodehint3(inputs)
	return de_profilelinkcodehint3(inputs)
});
export { profilelinkcodehint3 as "profileLinkCodeHint" }